import { render, staticRenderFns } from "./QuotationView.vue?vue&type=template&id=fe563e30&scoped=true"
import script from "./QuotationView.vue?vue&type=script&lang=js"
export * from "./QuotationView.vue?vue&type=script&lang=js"
import style0 from "./QuotationView.vue?vue&type=style&index=0&id=fe563e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe563e30",
  null
  
)

export default component.exports